import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getCatalogExports = api.injectEndpoints({
  endpoints: builder => ({
    getCatalogExports: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/pdf/product-catalog`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{}>;

export const {useLazyGetCatalogExportsQuery} = getCatalogExports;
